import { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApi } from '../services/api';
import { useCity } from '../contexts/CityContext';
import styles from './BusLineDetailPage.module.css';
import LineChip from '../components/common/LineChip';
import { MdSubway } from 'react-icons/md';
import { processTimetables } from '../utils/transportUtils';

// Metro hattı için arayüz tanımlaması
interface MetroLine {
  line_id: string;
  line_name: string;
  path_description: string;
  color?: string;
  start_station: string;
  end_station: string;
  active: boolean;
  operator?: {
    operator_id: number;
    operator_name: string;
    operator_logo?: string;
  };
  stations?: {
    station_id: string;
    station_name: string;
    order: number;
    latitude?: number;
    longitude?: number;
  }[];
  timetables?: any[];
  schedule?: {
    weekday: string[];
    saturday: string[];
    sunday: string[];
  };
}

function MetroLineDetailPage() {
  const { lineId } = useParams<{ lineId: string }>();
  const [lineDetail, setLineDetail] = useState<MetroLine | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const api = useApi();
  const { currentCity } = useCity();
  const navigate = useNavigate();

  const transportMode = 'metro';

  const getModeIcon = () => <MdSubway />;
  const getModeTitle = () => 'Metro';

  const fetchLineDetail = useCallback(async () => {
    if (!lineId || !currentCity) return;

    setLoading(true);
    setError(null);

    try {
      const response = await api.getTransportLine(transportMode, lineId);

      if (response && response.status === 'success' && response.data) {
        const lineData = response.data;

        if (lineData.timetables && lineData.timetables.length > 0) {
          lineData.schedule = processTimetables(lineData.timetables);
        }

        setLineDetail(lineData);
      } else {
        setError(`${getModeTitle()} hattı bilgisi bulunamadı.`);
      }
    } catch (err) {
      setError('Hat bilgileri yüklenirken bir sorun oluştu.');
    } finally {
      setLoading(false);
    }
  }, [lineId, transportMode, currentCity, api]);

  useEffect(() => {
    fetchLineDetail();
  }, [fetchLineDetail]);

  return (
    <div className={styles.lineDetailPage}>
      <div className={styles.backButtonContainer}>
        <button className={styles.backButton} onClick={() => navigate('/lines')}>
          ← Hatlara Dön
        </button>
      </div>

      {loading && <div className={styles.loadingMessage}>Yükleniyor...</div>}

      {error && <div className={styles.errorMessage}>{error}</div>}

      {!loading && !error && lineDetail && (
        <>
          <div className={styles.lineHeader}>
            <div className={styles.modeIndicator}>
              {getModeIcon()}
              <span>{getModeTitle()}</span>
            </div>
            <LineChip lineNumber={lineDetail.line_id} size="large" lineColor={lineDetail.color} />
            <h1 className={styles.lineName}>{lineDetail.line_name}</h1>
          </div>

          <div className={styles.lineDetailsCard}>
            <h3>Güzergah Açıklaması</h3>
            <p>{lineDetail.path_description}</p>
          </div>
        </>
      )}
    </div>
  );
}

export default MetroLineDetailPage;